import getOrderFileuri from '../../../Services/getOrderFileUri';

export default () => async (dispatch) => {

  // Incorrectly named service
  // Open all downloaded files & PDFs etc in new tab (instead of current one)
  dispatch(getOrderFileuri());

}